import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../../../common/Modal';
import IndividualValueEditForm from '../../../common/forms/IndividualValueEditForm';

export const EditModal = ({ modalType, onClose, ...rest }) => {
  if (!modalType) return null;

  return (
    <Modal onClose={onClose}>
      <IndividualValueEditForm modalType={modalType} {...rest} />
    </Modal>
  );
};

EditModal.propTypes = {
  modalType: PropTypes.string,
  onClose: PropTypes.func,
  currentValue: PropTypes.string,
  updatedValue: PropTypes.string,
  handleValueChange: PropTypes.func,
  inputType: PropTypes.string,
  selectOptions: PropTypes.arrayOf(
    PropTypes.shape({ display: PropTypes.string, value: PropTypes.string }),
  ),
  onSave: PropTypes.func,
  error: PropTypes.string,
};
